import React from 'react';
import { LogIn } from 'lucide-react';
import { Button } from '../ui/Button';
import { Logo } from '../ui/Logo';

interface Props {
  onLoginClick: () => void;
  onSignupClick: () => void;
}

export function SiteHeader({ onLoginClick, onSignupClick }: Props) {
  return (
    <header className="sticky top-0 z-40 bg-paper/85 backdrop-blur border-b border-ink-300/60">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-3.5 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={onLoginClick}
          className="bg-transparent border-none p-0 cursor-pointer btn-focus rounded-md"
          aria-label="Ir para o início"
        >
          <Logo variant="on-light" size="md" markSize={26} />
        </button>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onLoginClick} icon={LogIn}>
            <span className="hidden sm:inline">Entrar</span>
          </Button>
          <Button variant="primary" size="sm" onClick={onSignupClick}>
            Criar conta
          </Button>
        </div>
      </div>
    </header>
  );
}
